/** The booking "Diagnose" tab — a thin adapter over the shared AI chat panel
 *  (features/ai-diag). One backend tool (entity_diagnose) serves bookings,
 *  orders and users; the bracketed label token narrows the bgtasks listing
 *  without small-int substring collisions. */
import { useMemo } from 'react';

import * as bookingsApi from '@/api/bookings';
import { AiDiagChat } from '@/features/ai-diag/AiDiagChat';
import type { AiDiagAdapter } from '@/features/ai-diag/types';

export function AiDiagnosePanel({ bookingId, tenantId }: { bookingId: number; tenantId?: number | null }) {
  const adapter: AiDiagAdapter = useMemo(
    () => ({
      launchContext: bookingsApi.diagnoseLaunchContext,
      start: (body) => bookingsApi.startDiagnose(bookingId, body),
      taskType: 'entity_diagnose',
      subjectNoun: 'booking',
      subjectTitle: `Booking ${bookingId}`,
      questionPlaceholder: 'e.g. "Why did this booking disappear from the app?"',
      labelContains: `[booking:${bookingId}]`,
      matchesSubject: (params) =>
        (params as { booking_id?: number } | null)?.booking_id === bookingId,
      tenantId,
    }),
    [bookingId, tenantId],
  );
  return (
    <AiDiagChat
      adapter={adapter}
      subjectNote={
        'The AI reads this booking’s row, imports & webhooks, emitted events, ' +
        'mobile-cache state, tenant config, backend logs and the booking system’s ' +
        'current record — nothing else.'
      }
    />
  );
}
